<template>
  <div>
    <dv-border-box-7 style="width: 100%;height:100%">

      <div class="d-flex pt-2 pl-2" style="height:1vh;width: 100%;">
        <div style="font-size:16px;color:#5cd9e8;float:left;padding:5px"> 总交易数据
          <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
        </div>
      </div>
      <div style="width: 100%;height:20vh ;margin-top: 2vh;">
        <div style="width: 100%;height:88%;float:left;margin-left: 1%;">

          <div style="width: 15%;height:100%;float:left;margin-left: 1%;">
            <div id="publishNumChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>挂网项目总数</strong>
            </div>
          </div>

          <div style="width: 15%;height:100%;float:left;margin-left: 1%;">
            <div id="tradeNumChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>成交项目总数</strong>
            </div>
          </div>

          <div style="width: 15%;height:100%;float:left;margin-left: 1%;">
            <div id="tradeSumMoneyChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>线上成交总额（万元)</strong>
            </div>
          </div>

          <div style="width: 15%;height:100%;float:left;margin-left: 1%;">
            <div id="sumMuChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>资源性成交面积(亩)</strong>
            </div>
          </div>
          <div style="width: 15%;height:100%;float:left;margin-left: 1%;">
            <div id="sumMeterChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>经营性成交面积(㎡)</strong>
            </div>
          </div>

          <div style="width: 17%;height:100%;float:left;margin-left: 1%;">
            <div id="purSumMoneyChart" style="width:150px;height:15vh;margin-top: 1%;margin:  0 auto;"> </div>
            <div style="width: 100%;height:20%;font-size:14px;color:#5cd9e8;text-align: center;">
              <strong>工程招标和采购成交总额(万元)</strong>
            </div>
          </div>


        </div>
      </div>


    </dv-border-box-7>

  </div>
</template>

<script>
import "echarts-liquidfill/src/liquidFill.js"; // 在需要水滴图的页面js引入
import * as echarts from "echarts";

export default {
  name: "lef",
  props: {
    chartData: {
      type: Object,
      default: () => { }
    },
  },
  watch: {

  },
  data() {
    return {
      chartData: [],
      unitCode: localStorage.getItem("unitCode"),
    }
  },
  mounted() {
    this.getData();
    this.showChart('chartAllMoney', 100);
  },
  methods: {
   
    getData() {
      this.$http.get("/web/v2/transactionData?unitCode=" + this.unitCode).then((
        res) => {
        console.log(res.data.data)
        // this.publishNum=res.data.data.publishNum;
        // this.purSumMoney=res.data.data.purSumMoney;
        // this.sumMeter=res.data.data.sumMeter;
        // this.sumMu=res.data.data.sumMu;
        // this.tradeNum=res.data.data.tradeNum;
        // this.tradeSumMoney=res.data.data.tradeSumMoney;
       
        this.showChart('publishNumChart',res.data.data.publishNum,['#23cc72'],'#485C6D','#23cc72');

        this.showChart('tradeNumChart',res.data.data.tradeNum,['#81C784'],'#006064','#009688');
        //   this.showChart('tradeNumChart',res.data.data.tradeNum,['#26A69A'],'#00796B','#00ACC1');

        this.showChart('tradeSumMoneyChart',res.data.data.tradeSumMoney,['#26A69A'],'#00796B','#00ACC1');

         this.showChart('sumMuChart',res.data.data.sumMu,['#0097A7'],'#006064','#009688');
         this.showChart('sumMeterChart',res.data.data.sumMeter,['#1976D2'],'#006064','#0D47A1');
        this.showChart('purSumMoneyChart',res.data.data.purSumMoney,['#64B5F6'],'#006064','#1A237E');
      

      });
    },
    showChart(id,value,valveColor,lineColor,borderColor) {
      var option = {
        // backgroundColor: '#485C6D', //背景色
        series: [
          {
            type: 'liquidFill', //水位图
            radius: '90%', //显示比例
            center: ['50%', '50%'], //中心点
            amplitude: 10, //水波振幅
            data: [0.5, 0.5, 0.5], // data个数代表波浪数
            color: valveColor, //波浪颜色
            backgroundStyle: {
              borderWidth: 1, //外边框
              borderColor: borderColor, //边框颜色
              color: lineColor, //边框内部填充部分颜色
            },
            label: {
              //标签设置
              normal: {
                position: ['50%', '30%'],
                formatter: value+'', //显示文本,
                textStyle: {
                  fontSize: '18px', //文本字号,
                  color: '#23cc72',
                },
              },
            },
            outline: {
              show: false,//最外层边框显示控制
            },
          },
        ],
      };

      var myChart = echarts.init(document.getElementById(id));
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

  }
}
</script>

<style lang="scss" scoped>
.bar {
  padding: .15rem;
}

.barbox li,
.barbox2 li {
  width: 50%;
  text-align: center;
  position: relative;
  z-index: 100;
}

.barbox:before,
// .barbox:after{ position:absolute; width: .3rem; height: .1rem; content: ""; }
// .barbox:before{border-left: 2px solid #02a6b5;left: 0;border-top: 2px solid #02a6b5; }
// .barbox:after{border-right: 2px solid #02a6b5; right: 0; bottom: 0;border-bottom: 2px solid #02a6b5; }

.barbox li:first-child:before {
  position: absolute;
  content: "";
  height: 80%;
  width: 1px;
  background: rgba(255, 255, 255, .2);
  right: 0;
  top: 25%;
}

// .barbox{  border: 1px solid rgba(25,186,139,.17); position: relative;}
.barbox li {
  font-size: .7rem;
  color: #ffeb7b;
  padding: .05rem 0;
  font-family: electronicFont;
  font-weight: bold;
  list-style: none
}

.barbox2 li {
  font-size: .19rem;
  color: rgba(255, 255, 255, .7);
  padding-top: .1rem;
  list-style: none
}

.pulll_left {
  float: left;
}

.pulll_right {
  float: right;
}

#leftLevel {
  padding: 0.2rem;
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 98%;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
  }

  #parent::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  #parent {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
